export const redirectURL = () => {
    const redirectURL = document.querySelector('[vdx-redirect-url]');
    
    if (redirectURL) {
        window.location.href = redirectURL.getAttribute('vdx-redirect-url');
    }
    else {
        return;
    }
}